import InfiniteScroll from 'react-infinite-scroll-component';
import styled from 'styled-components';

// eslint-disable-next-line import/prefer-default-export
export const StyledInfiniteScroll = styled(InfiniteScroll)`
  display: flex;
  justify-content: center;
  flex-direction: column;
  overflow: inherit;
`;
